<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
      </el-form-item>
      <el-form-item label="当天日期" prop="currentDate">
          <!-- <el-input v-model="dataForm.currentDate" placeholder="当天日期"></el-input> -->
          <el-date-picker
                  v-model="dataForm.currentDate"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="今日进件" prop="todayTotalApply">
          <el-input v-model="dataForm.todayTotalApply" placeholder="今日进件"></el-input>
      </el-form-item>
          <el-form-item label="今日放款" prop="todayTotalLoan">
          <el-input v-model="dataForm.todayTotalLoan" placeholder="今日放款"></el-input>
      </el-form-item>
          <el-form-item label="今日津贴" prop="todayAwardLoan">
          <el-input v-model="dataForm.todayAwardLoan" placeholder="今日津贴"></el-input>
      </el-form-item>
              <!-- <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        currentDate: '',
        todayTotalApply: '',
        todayTotalLoan: '',
        todayAwardLoan: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        currentDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        todayTotalApply: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        todayTotalLoan: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        todayAwardLoan: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slteamcurrentstate/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slteamcurrentstate/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
